import UpdateClearanceCertificateObligationModal from './UpdateClearanceCertificateObligationModal'

export default UpdateClearanceCertificateObligationModal
